// frontend/src/utils/policy/applyResponsePolicyDecision.js
//
// Applies a validator decision without embedding policy meaning in this layer.
// A future server/API execution path may intercept REGENERATE and request a new
// model candidate. The browser implementation uses a governed fallback only
// when no admissible sentence remains.

import {
  RESPONSE_POLICY_ACTIONS,
  RESPONSE_POLICY_DECISIONS,
} from './responsePolicyContract';

function normalizeText(value = '') {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

export function applyResponsePolicyDecision(validation = {}, policy = null) {
  const decision = validation.decision || RESPONSE_POLICY_DECISIONS.ALLOW;

  if (decision === RESPONSE_POLICY_DECISIONS.ALLOW) {
    return normalizeText(validation.candidateResponse);
  }

  if (decision === RESPONSE_POLICY_DECISIONS.TRANSFORM) {
    const preserved = (validation.sentenceDecisions || [])
      .filter((item) => item.action === RESPONSE_POLICY_ACTIONS.PRESERVE)
      .map((item) => item.sentence);

    return normalizeText(preserved.join(' '));
  }

  if (
    decision === RESPONSE_POLICY_DECISIONS.REJECT ||
    decision === RESPONSE_POLICY_DECISIONS.REGENERATE
  ) {
    return normalizeText(policy?.fallbackResponse || validation.candidateResponse);
  }

  return normalizeText(validation.candidateResponse);
}

export default applyResponsePolicyDecision;
